import { TOOL } from '~/projects/sidekicker/constants/tools';
import { ProjectConfigType } from '~/projects/types';

export const PROJECT_NAME = 'Sidekicker';

const config: ProjectConfigType = {
  name: PROJECT_NAME,
  getLogo: () => {
    const { ReactComponent } = require('./assets/logo.svg');
    return ReactComponent;
  },
  getBigLogo: () => {
    const { ReactComponent } = require('./assets/logo_big.svg');
    return ReactComponent;
  },
  getSendIcon: () => {
    const { ReactComponent } = require('./assets/send.svg');
    return ReactComponent;
  },
  supportEmail: 'support@sidekicker.ai',
  isExtensionAvailable: false,
  showFrozenSubscriptionBlock: false,
  availableToolIds: Object.values(TOOL),
};

export default config;
